import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 880,
      width: 880,
    },
    dialogContent: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(2),
      paddingTop: 0,
    },
    title: {
      ...theme.typography.h3,
    },
    widget: {},
  }),
  { name: 'CreateContentPopup' }
);
